import type { AdminConfiguration } from "./configuration.types";

const read = (key: keyof ImportMetaEnv): string => String(import.meta.env[key] ?? "").trim();

export const configuration: AdminConfiguration = (() => {
  const mode = import.meta.env.VITE_TAYAN_ADMIN_MODE === "live" ? "live" : "demo";
  if (mode === "demo") return { mode, firebase: null, turnstileSiteKey: null };

  const firebase = {
    apiKey: read("VITE_TAYAN_ADMIN_FIREBASE_API_KEY"),
    appId: read("VITE_TAYAN_ADMIN_FIREBASE_APP_ID"),
    authDomain: read("VITE_TAYAN_ADMIN_FIREBASE_AUTH_DOMAIN"),
    projectId: read("VITE_TAYAN_ADMIN_FIREBASE_PROJECT_ID"),
    messagingSenderId: read("VITE_TAYAN_ADMIN_MESSAGING_SENDER_ID"),
  };
  const turnstileSiteKey = read("VITE_TAYAN_ADMIN_TURNSTILE_SITE_KEY");
  if (
    firebase.projectId !== "tayan-app" ||
    !firebase.apiKey ||
    !firebase.appId ||
    firebase.authDomain !== "tayan-app.firebaseapp.com" ||
    firebase.messagingSenderId !== "879533481162" ||
    !turnstileSiteKey
  ) {
    throw new Error("Tayan yönetim panelinin canlı Firebase yapılandırması eksik.");
  }
  return { mode, firebase, turnstileSiteKey };
})();
